import { useMfaModalContext } from '../../../shared/providers/MfaModalProvider';
import useTracking from '../../hooks/useTracking';
import { revokeAuthToken } from '../../../shared/service/auth';
import { clearLocalStorage } from '../storage';

export default function useLogout() {
  const { resetModalContext, setPullingInterval } = useMfaModalContext();
  const { user: UserAnalytics } = useTracking();

  const logout = async () => {
    setPullingInterval(false);
    resetModalContext();
    UserAnalytics.clearUser();

    await revokeAuthToken().catch(() => undefined);
    clearLocalStorage();

    window.location.replace('/login');
  };

  return { logout };
}
